// ═══════════════════════════════════════════════════════════════════════════
// Sincronización con el Worker + KV — extraída VERBATIM de v0.9.16.
//
// ⚠ El sync es BIDIRECCIONAL y automático: auto-push ~2 s tras cualquier
//   cambio, auto-pull cada 30 s. No existe modo de sólo lectura.
//   Dos entornos con el mismo token comparten y se sobrescriben el snapshot.
//
// ⚠ El snapshot INCLUYE la llave de Facturapi. En multi-inquilino eso es
//   inaceptable: sale del dispositivo en la Etapa 4.
// ═══════════════════════════════════════════════════════════════════════════

export function getCloudConfig() {
  try {
    const cfg = JSON.parse(localStorage.getItem("vt-cloud") || "{}");
    return { url: cfg.url || "", token: cfg.token || "", enabled: !!(cfg.url && cfg.token) };
  } catch { return { url: "", token: "", enabled: false }; }
}

export function saveCloudConfig(cfg) {
  localStorage.setItem("vt-cloud", JSON.stringify(cfg));
}

export async function cloudFetch(endpoint, method = "GET", body = null) {
  const cfg = getCloudConfig();
  if (!cfg.enabled) throw new Error("Cloud sync no configurado");
  const url = cfg.url.replace(/\/+$/, "") + endpoint;
  const opts = {
    method,
    headers: { "Authorization": "Bearer " + cfg.token, "Content-Type": "application/json" },
  };
  if (body) opts.body = typeof body === "string" ? body : JSON.stringify(body);
  const res = await fetch(url, opts);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: "Error " + res.status }));
    throw new Error(err.error || err.message || "Error " + res.status);
  }
  return res;
}

export async function cloudPull() {
  const res = await cloudFetch("/data");
  const data = await res.json();
  if (data.empty) return null;
  return data;
}

export async function cloudPush(snapshot) {
  await cloudFetch("/data", "PUT", snapshot);
}

export function getWorkerProxyUrl() {
  const cfg = getCloudConfig();
  if (cfg.enabled && cfg.url) return cfg.url.replace(/\/+$/, "") + "/fapi";
  return null;
}
